import { FullProjectIssue } from 'entities';

import { GetLabelFn } from 'types/general';
import { buildLabelGetter } from 'utils/translation';

interface IssueStatusConfig {
  code: string;
  getLabel: GetLabelFn;

  color: string;
}

export const issueStatuses = {
  resolved: {
    code: '0',
    name: 'Resolved',

    getLabel: buildLabelGetter('resolved'),

    color: '#00D39D',
  },

  active: {
    code: '1',
    name: 'Active',

    getLabel: buildLabelGetter('active'),

    color: '#1560CE',
  },

  closed: {
    code: '2',
    name: 'Closed',

    getLabel: buildLabelGetter('closed'),

    color: '#F3003A',
  },
};

export function isIssueOpen(issue: FullProjectIssue | null | undefined): boolean {
  if (!issue) return false;

  return issue.status === issueStatuses.active.code;
}

export const issueStatusesByCode: Record<string, IssueStatusConfig> = Object.fromEntries(
  Object.values(issueStatuses).map((config) => [config.code, config]),
);
